import checkout from "layouts/class/components/class-details/schemas/classForm";

const {
  formField: { className, classLevel, organization, subOrganization },
} = checkout;

export default {
  [className.name]: "",
  [classLevel.name]: null,
  [organization.name]: null,
  [subOrganization.name]: null,
};
